import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import InterviewPreviewModal from "./InterviewPreviewModal";
import { SecondaryButton } from "components/Buttons";
import { EditLink } from "components/Links";

const COMPONENTS = {
  button: SecondaryButton,
  link: EditLink,
};

/**
 * InterviewPreviewButton
 *
 * @param {Object} interviewData
 * @param {String} variant
 */
const InterviewPreview = ({ interviewData, variant = "button", ...props }) => {
  const [showPreview, setShowPreview] = useState(false);

  const Component = COMPONENTS[variant] || SecondaryButton;

  return (
    <>
      <Component onClick={() => setShowPreview(true)} disabled={!interviewData?.questions?.length} {...props}>
        <FormattedMessage id="Missions.Roles.RoleVetting.Interviews.PreviewButtonText" />
      </Component>

      <InterviewPreviewModal interviewData={interviewData} show={showPreview} closeStateFunction={setShowPreview} />
    </>
  );
};

InterviewPreview.propTypes = {
  interviewData: PropTypes.shape({
    name: PropTypes.string,
    introVideoUrl: PropTypes.string,
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        descriptionJson: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        video: PropTypes.string,
        timeLimitSeconds: PropTypes.number,
      })
    ),
  }),
  variant: PropTypes.oneOf(["button", "link"]),
};

export default InterviewPreview;
